import { SET_FIRE_ASSUMPTIONS, SET_FIRE_PROJECTION, FIRE_ASSUMPTIONS_INITIALIZED } from '../constants/actionTypes';
import { FIRE_ASSUMPTIONS_STORAGE_KEY, FIRE_PROJECTION_MAX_YEARS } from '../constants/fireDefaults';
import {
  computeFireNumber,
  computeFireProjection,
  computeYearsToFire,
  computeProgressPercent,
} from '../utils/fireCalculationUtils';
import { storage } from '../storage';

export function loadFireAssumptions() {
  return async dispatch => {
    try {
      const raw = await storage.getItem(FIRE_ASSUMPTIONS_STORAGE_KEY);
      if (raw) {
        const assumptions = JSON.parse(raw);
        dispatch({ type: SET_FIRE_ASSUMPTIONS, assumptions });
        return;
      }
    } catch (e) {
      // ignore parse errors
    }
    dispatch({ type: FIRE_ASSUMPTIONS_INITIALIZED });
  };
}

export function saveFireAssumptions(assumptions) {
  return async (dispatch, getState) => {
    await storage.setItem(FIRE_ASSUMPTIONS_STORAGE_KEY, JSON.stringify(assumptions));
    dispatch({ type: SET_FIRE_ASSUMPTIONS, assumptions });
    const currentNetWorth = getState().netWorthInfo.currentNetWorth;
    dispatch(computeFireProjectionAction(assumptions, currentNetWorth));
  };
}

export function computeFireProjectionAction(assumptions, currentNetWorth) {
  return dispatch => {
    const { annualSpending, annualSavings, currentAge, annualReturnRate, withdrawalRate } = assumptions;
    if (!annualSpending || !currentAge || annualSavings == null || Number.isNaN(annualSavings)) return;

    const fireNumber = computeFireNumber(annualSpending, withdrawalRate);
    const rawProjection = computeFireProjection(
      currentNetWorth,
      annualSavings,
      annualReturnRate,
      fireNumber,
      FIRE_PROJECTION_MAX_YEARS
    );
    const yearsToFire = computeYearsToFire(rawProjection, fireNumber);
    const currentYear = new Date().getFullYear();
    const yearlyData = rawProjection.map(d => ({ year: currentYear + d.year, netWorth: d.netWorth }));
    const retirementAge = yearsToFire !== null ? currentAge + yearsToFire : null;
    const progressPercent = computeProgressPercent(currentNetWorth, fireNumber);

    dispatch({
      type: SET_FIRE_PROJECTION,
      projection: { fireNumber, yearsToFire, retirementAge, progressPercent, yearlyData },
    });
  };
}
